import axios from "axios";

// Set the API URL dynamically from the environment
const API_URL = process.env.REACT_APP_API_URL;

// The smartAPI function now takes the method type as a parameter
export const smartAPI = async (data = {}, method = "GET", endpoint) => {
  try {
    const url = `${API_URL}/${endpoint}`;

    let response;
    switch (method.toUpperCase()) {
      case "POST":
        response = await axios.post(url, data); // POST request
        break;
      case "GET":
        response = await axios.get(url, { params: data }); // GET request (sending data as query parameters)
        break;
      case "PUT":
        response = await axios.put(url, data); // PUT request
        break;
      case "DELETE":
        response = await axios.delete(url, { data }); // DELETE request (sending data as body)
        break;
      default:
        throw new Error(`Unsupported method: ${method}`);
    }

    return response; // Return the API response
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Fout bij het verzenden, probeer later opnieuw."
    );
  }
};
